import Logomark from "@/components/Logomark";
import { Link } from "react-router-dom";
import PublicNav from "@/components/PublicNav";
import AnnouncementBar from "@/components/AnnouncementBar";
import ScrollProgressBar from "@/components/ScrollProgressBar";
import BackToTop from "@/components/BackToTop";

/**
 * Shared chrome for every public page.
 *
 * This used to declare its OWN nav — a second five-item menu with no Product
 * dropdown, no free-scan entry, and a different item set from the one the
 * landing page and /pricing render. Two menus on one site is a bug, not a
 * style, and it is why moving between the landing page and /features felt
 * like moving between two products. It now mounts the same AnnouncementBar +
 * PublicNav everything else does.
 */
const FOOTER_GROUPS = [
  {
    heading: "Product",
    links: [
      { to: "/features", label: "Features" },
      { to: "/early", label: "First jobs & students" },
      { to: "/government", label: "Government jobs" },
      { to: "/use-cases", label: "Use cases" },
      { to: "/pricing", label: "Pricing" },
      { to: "/guides", label: "Guides" },
      { to: "/compare", label: "Compare" },
      { to: "/demo", label: "Live demo" },
    ],
  },
  {
    heading: "Trust",
    links: [
      { to: "/security", label: "Security" },
      { to: "/privacy", label: "Privacy" },
      { to: "/terms", label: "Terms" },
      { to: "/faq", label: "FAQ" },
    ],
  },
  {
    heading: "Company",
    links: [
      { to: "/contact", label: "Contact" },
      { to: "/login", label: "Sign in" },
      { to: "/signup", label: "Start free" },
    ],
  },
];

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen bg-paper text-stone-950 flex flex-col">
      <ScrollProgressBar />
      <AnnouncementBar />
      <PublicNav />

      <main className="flex-1">{children}</main>

      <footer className="bg-night text-white/70" data-surface="night">
        <div className="max-w-7xl mx-auto px-6 py-16 grid gap-10 md:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <Logomark />
              <span className="font-heading font-bold tracking-tight text-lg text-white">NextOpp.io</span>
            </div>
            <p className="mt-4 text-sm text-white/60 max-w-xs leading-relaxed">
              AI job search, truthful resume tailoring, and application tracking — with you in control of every step.
            </p>
          </div>
          {FOOTER_GROUPS.map((g) => (
            <div key={g.heading}>
              <div className="u-label text-white/45 mb-4">{g.heading}</div>
              <ul className="space-y-2 text-sm">
                {g.links.map((l) => (
                  <li key={l.to}><Link to={l.to} className="text-white/70 hover:text-dawn-300 transition-colors">{l.label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="border-t border-white/10 py-6 text-center text-xs text-white/50">
          © {new Date().getFullYear()} NextOpp.io · We never invent experience. You approve every application.
        </div>
      </footer>
      <BackToTop />
    </div>
  );
}
